import restTypes from 'utils/rest/types';
import restStates from 'utils/rest/states';
import restInitState from 'utils/rest/initState';

const initialState = {
  claims: [],
};
const claimRestTypes = restTypes('claims');

const { fetchAllStart, fetchAllFinished } = claimRestTypes;

const claims = (state = { ...restInitState, ...initialState }, action = {}) => {
  switch (action.type) {
    case fetchAllStart:
      return {
        ...state,
        ...restStates.fetchAllStart,
      };

    case fetchAllFinished:
      return {
        ...state,
        ...restStates.fetchAllFinished,
        listOfClaims: action.payload.result ?? action.payload.claims,
        pageCurrent: action.payload.meta && action.payload.meta.currentPage,
        pagesTotal: action.payload.meta && action.payload.meta.totalPages,
        claims: action.payload.result || action.payload.claims,
      };

    default:
      return state;
  }
};

export default claims;
